import { Button } from 'blaze-ui/Button'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Modal } from 'almanac-ui/Modal'
import XSquareContained from 'blaze-ui/icons/24/XSquareContained'
import { AlertTriangle } from 'blaze-ui/icons'
import Styles from './DeleteWorkspaceOption.module.scss'

interface Props {
  onBack: () => void
  onDeleteWorkspace: () => void
  onKeepAccount: () => void
  onClose: () => void
  isLoading?: boolean
}

const removalItems = [
  {
    icon: XSquareContained,
    text: 'All posts and generated content',
    size: 22,
  },
  {
    icon: XSquareContained,
    text: 'Integrations and brand settings',
    size: 22,
  },
  {
    icon: XSquareContained,
    text: 'Your workspace and remaining credits',
    size: 22,
  },
  {
    icon: AlertTriangle,
    text: "This action is permanent and can't be undone.",
    size: 20,
  },
]

export const DeleteWorkspaceOption = ({
  onBack,
  onDeleteWorkspace,
  onKeepAccount,
  onClose,
  isLoading = false,
}: Props) => {
  return (
    <div className={Styles.container}>
      <Modal.Header title="Subscription canceled" onClose={onClose} />
      <div className={Styles.content}>
        <Heading level={2} color="var(--dark-80)">
          Your subscription has been canceled.
          <br />
          Blaze Autopilot is now turned off.
        </Heading>

        <div className={Styles.warningBox}>
          <Heading level={4} color="var(--dark-80)">
            Do you want to delete your workspace?
          </Heading>
          <Text variant="primary" color="var(--dark-80)">
            Deleting your workspace will permanently remove:
          </Text>
          <ul className={Styles.removalList}>
            {removalItems.map((item) => {
              const IconComponent = item.icon
              return (
                <li key={item.text} className={Styles.removalItem}>
                  <IconComponent color="var(--red-70)" size={item.size} />
                  <Text variant="primary" color="var(--dark-80)">
                    {item.text}
                  </Text>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
      <div className={Styles.footer}>
        <Button variant="tertiary" size="lg" onPress={onBack} isDisabled={isLoading}>
          Back
        </Button>
        <div className={Styles.buttonGroup}>
          <Button
            variant="secondary"
            size="lg"
            onPress={onDeleteWorkspace}
            isDisabled={isLoading}
            className={Styles.deleteButton}
            frontIcon={AlertTriangle}
          >
            Delete Workspace
          </Button>
          <Button variant="primary" size="lg" onPress={onKeepAccount} isDisabled={isLoading}>
            Keep My Workspace
          </Button>
        </div>
      </div>
    </div>
  )
}
